import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { Result } from "../../interfaces/ICompetitions";

interface FinalResultRowProps {
  result: Result;
}

export default function FinalResultRow({ result }: FinalResultRowProps) {
  return (
    <TableRow>
      <TableCell
        sx={{ fontSize: { xs: "0.875rem", sm: "0.9375rem" }, width: "40px" }}
        align="center"
      >
        {result.place ?? "-"}
      </TableCell>
      <TableCell
        sx={{
          fontSize: { xs: "0.875rem", sm: "0.9375rem" },
          width: "60px",
          paddingLeft: { xs: 1, sm: 1.5 },
          paddingRight: { xs: 1, sm: 1.5 },
        }}
        align="center"
      >
        {result.presentations?.map((p, i) => (
          <React.Fragment key={p.id}>
            {p.id}
            {i < (result.presentations?.length ?? 0) - 1 && <br />}
          </React.Fragment>
        )) ?? result.presentation.id}
      </TableCell>
      <TableCell sx={{ fontSize: { xs: "0.875rem", sm: "0.9375rem" } }} align="left">
        {result.presentations?.map((p, i) => (
          <React.Fragment key={p.id}>
            {p.name}
            {i < (result.presentations?.length ?? 0) - 1 && <br />}
          </React.Fragment>
        )) ?? result.presentation.name}
      </TableCell>
    </TableRow>
  );
}

